module.exports = __webpack_public_path__ + "static/media/image-992.696b79d4.jpg";